import { faImage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';

const EditJobTypeModal = ({ isOpen, onClose, onEditType, initialData }) => {
    const [name, setName] = useState('');
    const [errors, setErrors] = useState({});
    const [currentImage, setCurrentImage] = useState('');
    const [image, setImage] = useState(null);
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
            setErrors((prev) => ({ ...prev, image: '' }));
            const reader = new FileReader();
            reader.onloadend = () => {
                setCurrentImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };
    useEffect(() => {
        if (initialData) {
            setName(initialData.name || '');
            setCurrentImage(initialData?.media?.length > 0 ? initialData?.media[0]?.original_url : null);
        }
    }, [initialData, isOpen]);

    const handleSubmit = (e) => {
        e.preventDefault();

        const validationErrors = {};

        if (name.trim() === '') {
            validationErrors.name = 'Job type name is required';
        }

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        onEditType(initialData.id, name, image, initialData?.job_type_id);
        setErrors({});
        setCurrentImage('');
        setName('');
        setImage(null);
        onClose();
    };

    const handleInputChange = (setter) => (e) => {
        setter(e.target.value);
        setErrors((prev) => ({ ...prev, [e.target.name]: '' }));
    };

    if (!isOpen) return null;

    const ClearData = () => {
        setCurrentImage('');
        setName('');
        setImage(null);
        setErrors({});
    };

    return (
        <div className="overlay">
            <div className="mymodal">
                <div className="modal-content">
                    <h2>Edit Job Type</h2>
                    <form className="add-class-form addAdminForm" onSubmit={handleSubmit}>
                        <label htmlFor="BrandImage" className='FormImageAvatarLabel'>
                            <input
                                type="file"
                                id='BrandImage'
                                className='d-none'
                                accept="image/*"
                                onChange={handleImageChange}
                            />
                            <div className="FormImageAvatar relative">
                                <FontAwesomeIcon icon={faImage} className='absolute' />
                                {currentImage &&
                                    <img src={currentImage} className='' width="100%" alt="News Preview" />
                                }
                            </div>


                        </label>
                        <label>
                            <div className="ModalInputTitle">
                                Type
                            </div>
                            <input
                                type="text"
                                name="name"
                                className='form-control'
                                placeholder='type'
                                value={name}
                                onChange={handleInputChange(setName)}
                            />
                            {errors.name && <div className="text-danger PopUpError mt-0">{errors.name}</div>}
                        </label>

                        <div className="form-buttons AllClassesBtn ApplicationButtons">
                            <button className="ModalBtn" type="submit">
                                Save
                            </button>
                            <button className="ModalBtn" type="button" onClick={() => { onClose(); ClearData(); }}>
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default EditJobTypeModal;
